"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Button = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _reactBootstrap = require("react-bootstrap");
var _ButtonModule = _interopRequireDefault(require("./Button.module.css"));
var _excluded = ["variant", "outline", "backgroundColor", "color", "play", "children", "style", "className", "loading"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var Button = function Button(_ref) {
  var variant = _ref.variant,
    outline = _ref.outline,
    backgroundColor = _ref.backgroundColor,
    color = _ref.color,
    play = _ref.play,
    _ref$children = _ref.children,
    children = _ref$children === void 0 ? 'ღილაკი' : _ref$children,
    style = _ref.style,
    className = _ref.className,
    loading = _ref.loading,
    props = _objectWithoutProperties(_ref, _excluded);
  //const [loading, setLoading] = useState(false);
  /*const clickHandler = () => {
    if (loader) {
      setLoading(true);
      onClick().then((payload) => {
        setTimeout(() => {
          setLoading(false);
          callback(payload);
        }, 2000);
      });
    } else onClick();
  };*/
  return /*#__PURE__*/_react.default.createElement(_reactBootstrap.Button, _extends({
    variant: outline ? "outline-".concat(variant) : variant,
    style: _objectSpread({}, style),
    className: (0, _classnames.default)(_ButtonModule.default.btn, className, play.show && _ButtonModule.default.play, loading && _ButtonModule.default.loader),
    disabled: loading
  }, props), children, play.show && /*#__PURE__*/_react.default.createElement("span", {
    className: _ButtonModule.default.iconContainer,
    style: {
      color: play.color
    }
  }, /*#__PURE__*/_react.default.createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: _freeSolidSvgIcons.faPlay,
    className: _ButtonModule.default.icon
  })));
};
exports.Button = Button;
Button.propTypes = {
  variant: _propTypes.default.oneOf(['primary', 'secondary', 'success', 'warning', 'danger', 'info', 'light', 'dark', 'link']),
  outline: _propTypes.default.bool,
  /*fontFamily: PropTypes.oneOf(['lbet-mt-regular', 'lbet-nus-regular']),*/
  size: _propTypes.default.oneOf(['sm', 'lg']),
  loading: _propTypes.default.bool,
  play: _propTypes.default.object
};
Button.defaultProps = {
  variant: 'primary',
  outline: false,
  /*fontFamily: 'lbet-mt-regular',*/
  size: 'lg',
  loading: false,
  play: {
    show: false,
    color: '#5b9215'
  }
};